/*!
 * 方案普通动作操作函数名 关联 v 1.0
 * 函数参数尽量为 id 和 参数
 *
 */
import * as transparencyMap from "@/components/tables/transparency/map.js";
import * as shpInfoListMap from "@/components/tables/shpInfoList/map.js";
import * as plotOperation from "@/components/tables/plotItem/plotConfig.js";
import * as kmlMap from "@/components/tables/program/map.js";
import * as modelMap from "@/views/index/map.js";
import * as pitMap from "@/mapUtils/TerrainUtils.js";
import * as roaming from "@/components/tables/customRoaming/map.js";
import * as rotatePointMap from "@/components/tables/rotatePoint/map.js";
import * as modelDyeingMap from "@/components/tables/customRoaming/map.js";
import * as modelFlatMap from "@/components/tables/modelFlattening/map.js";
import * as modelMapInit from "@/components/tables/program/scenerModel/map.js";
import * as photoGraphic from "@/components/common/photoGraphic/map.js";
import * as compare from "@/components/tables/compare/map.js";
import * as terrainMap from "@/components/tables/terrainElevation/map.js";
import * as fixedRoute from "@/components/tables/fixedRoute/trafficSimulation.js";
import * as sectioning from "@/components/tables/newModelCut/map.js";
import * as viewpoint from "@/components/tables/viewpoint/viewpointMap.js";
import * as constructionSimulation from "@/components/tables/animation/constructionSimulation/map.js";
import * as animation from "@/components/tables/animation/map.js";
import * as fixedRoute_ptv from "@/components/tables/fixedRoute/PTV_trafficFlow.js";

export const screenplayFn = {
  // 地下
  underground: {
    opacity: kmlMap.setUnderground,
    init: kmlMap.setUnderground,
  },
  // 模型
  model: {
    show: modelMap.modelAddRemove,
    init: modelMapInit.deleteModel,
    // 着色
    overallStaining: modelMapInit.dyeing("overall"),
    opacity: modelMapInit.opacity,
  },
  // 高程影像
  elevationImage: {
    opacity: transparencyMap.adjustTileOpacity,
    brightness: transparencyMap.adjustTileBrightness,
  },
  //  倾斜摄影
  obliquePhotography: {
    opacity: transparencyMap.adjustOsgbOpacity,
    init: transparencyMap.adjustOsgbOpacity,
  },
  // shp
  shp: {
    show: shpInfoListMap.showChinaLineId,
    init: shpInfoListMap.init,
  },
  // 标绘
  plot: {
    show: plotOperation.operationPlotData,
    init: plotOperation.deleteAllPlot,
  },
  // kml
  kml: {
    show: kmlMap.showKmlLayerId,
    init: kmlMap.removeLayer,
  },
  // 挖坑
  pit: {
    show: pitMap.scenarioDigHoleOperation,
    init: pitMap.deleteAllPit,
  },
  // 漫游 参数 start，pause，continue，stop
  roaming: {
    operate: roaming.handleCustomRoaming,
    init: roaming.init,
  },
  // 绕点
  rotatePoint: {
    fly: rotatePointMap.handleRotateView,
    init: rotatePointMap.init,
  },
  // 模型压平
  modelFlat: {
    operate: modelFlatMap.modelExcavationFlating,
    adjust: modelFlatMap.adjustHeight,
  },
  // 视角飞行
  flight: {
    flight: photoGraphic.flight,
  },
  // 分屏
  splitScreen: {
    open: compare.open,
    init: compare.init,
  },
  // 地形
  terrain: {
    show: terrainMap.terrainSwitch,
  },
  // 交通模拟
  fixedRoute: {
    operate: fixedRoute.handleTrafficSimulation,
    init: fixedRoute.init,
  },
  // 剖切
  sectioning: {
    start: sectioning.demonstrate,
    init: sectioning.init,
  },
  // 视点飞行
  viewpoint: {
    operate: viewpoint.handleCustomRoaming,
    init: viewpoint.init,
  },
  //交通模拟ptv
  fixedRoute_ptv: {
    operate: fixedRoute_ptv.handleTrafficSimulation,
    init: fixedRoute_ptv.removeLayer,
  },
  // 动画 - 施工模拟
  animation: {
    componentDyeing: animation.componentDyeing,
    start: animation.start,
    init: animation.init,
  },
  // 施工模拟
  constructionSimulation: {
    componentStaining: constructionSimulation.componentStaining,
  },
};

export default screenplayFn;
